<template>
  <div
    :class="[
      'faq__item',
      {faq_active: active}
    ]"
  >
    <h3 class="faq__question" @click="(event) => $emit('click', event)">
      <div class="faq__control"></div>
      {{item.q}}
    </h3>

    <div class="faq__answer">
      <p v-html="item.a"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpandPanel",

  props: ["item", "active"],
}
</script>

<style lang="sass">
@import '../../../sass/variables'

.faq__item
  display: flex
  flex-direction: column
  position: relative
  width: 100%
  border-radius: 16px
  background: rgba(255, 255, 255, 1)
  transition: .4s ease

  &:hover
    background: rgba(238, 238, 238, 1)

  .faq__control
    min-width: 40px
    height: 40px
    transition: .4s ease
    background: url($baseUrl + 'landing/arrow-down.svg') no-repeat center center / contain
    margin-right: 20px

  &.faq_active
    .faq__control
      transform: rotate(180deg)

  .faq__question
    display: flex
    justify-content: flex-start
    align-items: center
    text-align: left
    gap: 16px
    padding: 24px 24px 10px 24px
    font-size: 18px
    font-weight: 700
    line-height: 24px
    color: rgba(7, 24, 45, 1)
    cursor: pointer

  .faq__answer
    padding: 0
    max-height: 0
    overflow: hidden
    transition: .4s ease

    p
      text-align: left
      font-weight: 400
      font-size: 16px
      line-height: 24px
      padding: 0 40px 24px
      color: rgba(76, 96, 122, 1)
</style>
